import * as React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ViewUser, ViewUserWallet, SharedTransactions } from "@njoy/controller";

// import CP from "../../assets/wallet/cp-icon.png";
import TotalDebit from "../../assets/wallet/total-debit.png";
import LocationIcon from "../../assets/wallet/location-icon.png";
import ProfileBg from "../../assets/wallet/profile-bg.png";
import { TemplateSub } from "../../components/layouts/TemplateSub";
import SendIconInfo from "../../assets/wallet/send-icon-info.png";
import { BackButton } from "../../components/uiMerge/backButton";
import * as ROUTES from "../../constants/routes";
import AntAvatar from "../shared/AntAvatar";
import moment from "moment";
// import TotalCredit from "../../assets/wallet/total-credit.png";

export const SendInfoDetailsPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // const customerId = searchParams.get("user");
  const userId = searchParams.get("user");
  const [userWalletId, setUserWalletId] = React.useState("");

  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/";
    }
  };

  function formatWalletBalance(balance: number): string {
    return balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  React.useEffect(() => {
    const userWalletId = localStorage.getItem("userWalletId") || "";

    setUserWalletId(userWalletId);
  }, [])

  return (
    <TemplateSub page={`Quick Info`} bgImg={`url(${ProfileBg})`}>
      {!userId ? (
        <p className="text-white px-4 mt-4">No customer ID provided</p>
      ) : (
        <ViewUser userId={userId}>
          {({ user, loading }) =>
            loading ? (
              <p className="text-white px-4 mt-4">Fetching...</p>
            ) : user ? (
              <ViewUserWallet userId={userId}>
                {({wallet, loading}) => (
                  <div className="w-full flex-1 pb-4">
                    <div
                    className="h-48 relative px-4 w-full overflow-hidden shadow-md bg-cover bg-center"
                    style={{ backgroundImage: `url(${ProfileBg})` }}>
                      <div className="flex items-center p-4 w-full gap-24 mt-12 ">
                        <BackButton onClick={handleBack} />
                        <p className="text-[20px] font-[900] text-white">Quick Info</p>
                      </div>
                    </div>

                    {/* Customer Details */}
                    <div className="w-full max-w-[450px] mx-auto  px-[1rem] -mt-10 relative z-10">
                      <div className="flex items-center justify-between ">
                        <div className="flex flex-col mt-1 gap-3 ">
                          <div className="w-[71px] h-[71px] rounded-full overflow-hidden">
                            {user.__typename === "AdminPWA" &&
                              (user.merchantProfile?.logoUrl ?
                                <img 
                                  src={user.merchantProfile.logoUrl} 
                                  alt="" 
                                  className="w-full h-full object-cover"
                                /> : 
                                <AntAvatar 
                                  firstname={user.merchantProfile?.companyName || ""}
                                  width="71px" 
                                  height="71px" 
                                  fontSize="28px" 
                                />
                              )
                            }

                            {user.__typename === "CustomerPWA" &&
                              <AntAvatar 
                                firstname={user?.firstname || ""} 
                                lastname={user?.lastname!} 
                                width="71px" 
                                height="71px" 
                                fontSize="28px"
                              />
                            }
                          </div>
                          
                          <div className="flex flex-col">
                            {user.__typename === "AdminPWA" && 
                              <>
                                <p className=" text-[20px] text-white font-semibold">
                                  {user.merchantProfile?.companyName}
                                </p>

                                <p className="text-[12px] text-[#777] ">@{user.merchantProfile?.username}</p>

                                <div className="flex gap-1 mt-1 items-start">
                                  <img src={LocationIcon} alt="location" width={16} height={16} />

                                  <p className="text-[12px] text-[#777] ">
                                    {user.merchantProfile?.companyLocation}
                                  </p>
                                </div>
                              </>
                            }

                            {user.__typename === "CustomerPWA" && 
                              <>
                                <p className=" text-[20px] text-white font-semibold">
                                  {user.firstname} {user.lastname}
                                </p>

                                <p className="text-[12px] text-[#777] ">@{user.username}</p>
                              </>
                            }
                          </div>
                        </div>

                        {
                          loading ? (
                            <p className="text-white flex justify-center items-center">Loading...</p>
                          ) : (
                            <button
                            className="flex gap-3 item-center rounded-[10px] border border-white py-2 px-6 mt-8"
                            onClick={() => navigate(`${ROUTES.VIEW_SEND_MONEY_DETAILS}?user=${userId}&barterId=${wallet?.barterId}`)}>
                              <img src={SendIconInfo} alt="" width={18} height={18} />
                              <p className="text-white text-[14px] h-[0]">Send</p>
                            </button>
                          )
                        }
                      </div>
                    </div>

                    {/* Transaction History Section */}
                    <div className="mt-4 px-[1rem] pb-4">
                      <p className="text-white text-[16px]">Transaction History</p>
                      <SharedTransactions 
                        variables={{
                          offset: 0, 
                          limit: 5, 
                          walletId: userWalletId,
                          recipientWalletId: wallet?.id || ""
                        }}
                      >
                        {({myTransactions}) => {

                          // console.log("my transactions ", myTransactions)

                          return(
                            <>
                              <div className="w-full mt-4">
                                {myTransactions.length > 0 ? (
                                  myTransactions.map((group:any, i:any) => (
                                    <div
                                      key={i}
                                      className="w-full p-5 bg-[#1E1E1E] rounded-lg mb-4"
                                    >
                                      {/* Group Date */}
                                      <div className="flex items-center justify-between">
                                        <p className="text-white text-[15px] text-left">
                                          {new Date(group.createdAt).toDateString()}
                                        </p>
                                      </div>
                                      <hr className="bg-[#77777] mt-3 border border-[#7777]" />

                                      {/* Transactions inside the group */}
                                      {group.transactions.map((tx:any) => (
                                        <div
                                          key={tx.id}
                                          className="flex justify-between items-center cursor-pointer mt-3"
                                        >
                                          <div className="flex items-center gap-2 w-[55%]">
                                            <div>
                                              <img
                                                src={TotalDebit}
                                                alt="debit"
                                                width={27}
                                                height={27}
                                              />
                                            </div>
                                            <div className="flex flex-col gap-1">
                                              {
                                                tx.recipientWallet.owner.customer === null ? (
                                                  <p className="text-[12px] text-white font-semibold">
                                                    {tx.recipientWallet?.owner?.admin?.merchantProfile?.companyName || tx.type}
                                                  </p>
                                                ) : (
                                                  <p className="text-[12px] text-white font-semibold">
                                                    {tx.recipientWallet.owner.customer.firstname}{" "} {tx.recipientWallet.owner.customer.lastname}
                                                  </p>
                                                )
                                              }
                                              <div className="flex items-center gap-1.5">
                                                <p className="text-[12px] text-[#777]">
                                                  {new Date(tx.createdAt).toLocaleDateString()}
                                                </p>
                                                <p className="text-[12px] text-[#777]">
                                                  {moment(tx.createdAt).format("h:mm A")}
                                                </p>
                                              </div>
                                            </div>
                                          </div>

                                          {/* Amount */}
                                          <div>
                                            <p className="text-white text-[12px]">
                                              {tx.currency === "NGN" ? (<span>&#8358;</span>) : ""}  {" "} {formatWalletBalance(tx.amount)}
                                            </p>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ))
                                ) : (
                                  // Empty state
                                  <div className="flex items-center justify-center px-2 gap-3 w-full p-4 mt-6 bg-[#1E1E1E] rounded-lg">
                                    <p className="text-[#B2B2B2] text-[14px]">
                                      No Recent Transactions
                                    </p>
                                  </div>
                                )}
                              </div>
                            </>
                          )
                        }}
                      </SharedTransactions>
                    </div>
                  </div>
                )}
              </ViewUserWallet>
            ) : (
              <p className="text-white px-4 mt-4">Customer not found</p>
            )
          }
        </ViewUser>
      )}
    </TemplateSub>
  );
};
